export default class FileNameUtils {
    static getFileIconClass(extension) {
        // Strip . from start of extension
        let fileExtension = (extension || "").toLowerCase();
        if (fileExtension.startsWith(".")) {
            fileExtension = fileExtension.substr(1);
        }
        switch (fileExtension) {
            case "doc":
            case "docx":
                return "fa-file-word";
            case "xls":
            case "xlsx":
                return "fa-file-excel";
            case "ppt":
            case "pptx":
                return "fa-file-powerpoint";
            case "txt":
                return "fa-file-alt";
            case "mdb":
                return "fa-database";
            case "wav":
                return "fa-file-audio";
            case "gif":
            case "jpeg":
            case "jpg":
            case "png":
                return "fa-file-image";
            case "pdf":
                return "fa-file-pdf";
            case "zip":
                return "fa-file-archive";
            default:
                return "fa-file";
        }
    }
}
